import { render } from "./DataThumbnail.vue?vue&type=template&id=19a0e9c6&scoped=true"
import script from "./DataThumbnail.vue?vue&type=script&lang=js"
export * from "./DataThumbnail.vue?vue&type=script&lang=js"

import "./DataThumbnail.vue?vue&type=style&index=0&id=19a0e9c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19a0e9c6"

export default script